import { Auth } from "aws-amplify";
import axios from "axios";
import { getTenantIdFromUrl } from "lib/utils";
import history from "app/history";

export const getSessionToken = async () => {
  const session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
};

export const getCurrentTenantId = () => {
  return getTenantIdFromUrl(window.location.href);
};

export const idTokenInterceptor = async (config) => {
  const newConfig = { ...config };
  /* The method currentSession will hit aws-amplify internal cache
  to get the session of the user. If the session is expired, it will
  call Cognito for new ID and Access tokens if the Refresh token is 
  not expired. If it is, the value of the Token will be undefined */
  try {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken().getJwtToken();

    newConfig.headers.Authorization = idToken;
  } catch (error) {
    // Cancel the request
    const source = axios.CancelToken.source();
    newConfig.cancelToken = source.token;
    source.cancel();

    // Session is expired, sign out the user
    history.push({
      pathname: "/logout",
      state: {
        message: "Your session has expired. Please log in again",
        type: "info",
      },
    });
  }

  return newConfig;
};

export const addTenantHeaderInterceptor = (config) => {
  const newConfig = { ...config };
  const tenantId = getCurrentTenantId();

  if (tenantId) newConfig.headers["X-Tenant"] = tenantId;

  return newConfig;
};

export const successHandler = (res) => res;

export const errorHandler = async (error) => {
  // User is not authorized
  if (error.response?.status === 403) {
    history.push({
      pathname: "/logout",
      state: {
        message: "You are not authorized to access this data",
      },
    });
  }

  throw error;
};
